














































































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";

// Component
import Treeselect from "@riophae/vue-treeselect";

// Treeselect Styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import BrandsStore from "@/mixins/brandsStore";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import PriceListsStore from "@/mixins/priceListsStore";

// Enums/Data
import { DiscountTypes, PromotionTypes } from "@/data/enums/promotions";

// Types
import { IPromotionForm } from "@/models/promotions";
import { ICurrency } from "@/models/constants";
import { IPricelist } from "@/models/products";

@Component({
  components: {
    Treeselect,
    "billing-terms-field": () =>
      import(
        "@/components/app/admin/catalogue/promotions/billingTermsField.vue"
      )
  }
})
export default class DiscountAndConditions extends Mixins(
  HasValidation,
  BrandsStore,
  CurrenciesStore,
  BillingCyclesStore,
  PriceListsStore
) {
  // Props
  @Prop({ required: true })
  public value!: IPromotionForm;

  @Prop({ required: true })
  public isDisabled!: boolean;

  @Prop({ default: 0 })
  public minValue!: number;

  @Prop({ default: false })
  public useLimitQuantity!: boolean;

  @Prop({ default: false })
  public isMandatory!: boolean;

  // Data
  public discountTypes = DiscountTypes;
  public promotionTypes = PromotionTypes;

  public useAllCurrencies = true;
  public useAllPriceLists = true;
  public limitQuantity = false;
  public isLoading = true;

  // Getters
  public get form() {
    return this.value;
  }

  public set form(value) {
    this.$emit("input", value);
  }

  public async created() {
    try {
      await Promise.all([
        this.getCurrencies(),
        this.getPriceLists(),
        this.getBillingCycles()
      ]);

      const formCurrencies = this.$_.get(this.form, "currencies") || [];
      this.useAllCurrencies = formCurrencies.length === 0;

      const formPriceLists = this.$_.get(this.form, "pricelists") || [];
      this.useAllPriceLists = formPriceLists.length === 0;

      this.limitQuantity =
        this.$_.get(this.form, "min_quantity", null) !== null ||
        this.$_.get(this.form, "max_quantity", null) !== null;

      this.onLimitQuantityChange(this.limitQuantity);
    } finally {
      this.isLoading = false;
    }
  }

  public get isMoneyBased() {
    return this.form.type === DiscountTypes.MONEY_BASED;
  }

  public get currency() {
    if (!this.isMoneyBased) return {};

    return this.$_.find(this.currencies, ["id", this.form.currency_id]) || {};
  }

  public get allUseableCurrencies() {
    return this.$_.uniqBy(
      this.$_.orderBy(
        this.$_.concat(
          this.brandCurrencies,
          this.isMoneyBased
            ? [this.$_.find(this.currencies, ["id", this.form.currency_id])]
            : this.$_.filter(this.currencies, currency => {
                return this.$_.find(
                  this.$_.get(this.form, "currencies", []),
                  formCurrency => {
                    return formCurrency === currency.id;
                  }
                );
              })
        ),
        "name",
        "asc"
      ),
      "id"
    );
  }

  public get treeSelectCurrencies() {
    return this.$_.map(this.allUseableCurrencies, (currency: ICurrency) => {
      return {
        id: currency.id,
        label: currency.code
      };
    });
  }

  public get treeSelectPricelists() {
    return this.$_.map(this.priceLists, (priceList: IPricelist) => {
      return {
        id: priceList.id,
        label: priceList.name
      };
    });
  }

  public get minQuantityValidation() {
    return `required|min_value:1${
      this.$_.get(this.form, "max_quantity", null)
        ? `|max_value:${this.form.max_quantity}`
        : ""
    }`;
  }

  public get maxQuantityValidation() {
    return `min_value:${this.$_.get(this.form, "min_quantity", 1)}`;
  }

  @Watch("useAllCurrencies")
  public onAllCurrenciesChange() {
    if (!this.useAllCurrencies) return;
    this.$set(this.form, "currencies", []);
  }

  @Watch("useAllPriceLists")
  public onAllPriceListsChange() {
    if (!this.useAllPriceLists) return;

    this.$set(this.form, "pricelists", []);
  }

  @Watch("limitQuantity")
  public onLimitQuantityChange(value) {
    if (value) {
      this.$set(this.form, "min_quantity", 1);
      return;
    }

    this.$set(this.form, "min_quantity", null);
    this.$set(this.form, "max_quantity", null);

    if (this.isLoading) {
      this.$emit("initialiseFormClone");
    }
  }

  @Watch("form.type")
  public onDiscountTypeChanged() {
    if (this.isMandatory) {
      delete this.form.currency_id;
      return;
    }

    this.$set(this.form, "currencies", this.isMoneyBased ? null : []);
    this.$set(
      this.form,
      "currency_id",
      this.isMoneyBased ? this.brandCurrencyId : null
    );
  }
}
